import React, { useEffect, useState } from 'react';
import { getAuth } from 'firebase/auth';
import { app } from '../firebase/firebase-config';
import axios from 'axios';
import Sidebar from './Sidebar';
import ProfileTab from './tabs/ProfileTab';
import LocationTab from './tabs/LocationTab';
import ServicesTab from './tabs/ServicesTab';
import AvailabilityTab from './tabs/AvailabilityTab';
import AppointmentsTab from './tabs/AppointmentsTab';
import MessagesTab from './tabs/MessagesTab';
import RatingsTab from './tabs/RatingsTab';
import { useMobileNav } from '../../contexts/MobileNavContext';
import './account.css';

const auth = getAuth(app);

const Account = () => {
    const [userDetails, setUserDetails] = useState(null);
    const [activeTab, setActiveTab] = useState('profile');
    const [userRole, setUserRole] = useState('client');
    const { isSidebarOpen } = useMobileNav();

    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            if (user) {
                axios.get(`${process.env.REACT_APP_API_BASE_URL}/users`)
                    .then((response) => {
                        const foundUser = response.data.find(
                            (u) => u.email.toLowerCase() === user.email.toLowerCase()
                        );

                        if (foundUser) {
                            // If healer, fetch healerProfile for description
                            if (foundUser.role === 'healer') {
                                axios.get(`${process.env.REACT_APP_API_BASE_URL}/users/${foundUser.id}`)
                                    .then(async (userRes) => {
                                        const userResData = userRes.data;
                                        console.log(userResData);
                                        await axios.get(`${process.env.REACT_APP_API_BASE_URL}/stripeAccount/${userResData.stripeaccount}`)
                                        .then((stripeRes)=>{
                                            const stripeData = stripeRes.data;
                                            console.log(stripeData.requirements);
                                            if(stripeData && stripeData.requirements.currently_due.length > 0){  //if there is missing info
                                                alert("Your Stripe Account still need some attention. Please go to your profile to find a button to resend the link");
                                                userResData.missingStripeInfo = stripeData.requirements.currently_due;
                                            }
                                        })
                                        .catch(err=>{
                                            console.log("Error fetching Stripe account details:", err);
                                        })
                                        const userData = {
                                            ...userResData,
                                            bio: userResData.healerProfile?.description || '',
                                            missingStripeInfo: userResData.missingStripeInfo? userResData.missingStripeInfo : null
                                        };
                                        setUserDetails(userData);
                                        setUserRole(foundUser.role || 'client');
                                        //stripe can sometime be missing informations from healer. THe below is to verify
                                       
                                    });
                            
                            } else {
                                // For clients, do not include bio
                                const userData = {
                                    id: foundUser.id,
                                    firstname: foundUser.firstname || '',
                                    lastname: foundUser.lastname || '',
                                    email: foundUser.email || '',
                                    phone: foundUser.phone || '',
                                    services: foundUser.services || '',
                                    servicePrices: foundUser.servicePrices || '',
                                    role: foundUser.role || 'client'
                                };
                                setUserDetails(userData);
                                setUserRole(foundUser.role || 'client');
                            }
                        }
                    });
            } else {
                alert("You must be logged in to access this page.");
                window.location.assign('/login');
            }
        });
    }, []);

    const handleTabChange = (tabId) => {
        setActiveTab(tabId);
    };

    const handleUserUpdate = (updatedUser) => {
        setUserDetails(updatedUser);
    };

    const renderTabContent = () => {
        switch (activeTab) {
            case 'profile':
                return <ProfileTab userDetails={userDetails} onUserUpdate={handleUserUpdate} />;
            case 'location':
                return <LocationTab userDetails={userDetails} onUserUpdate={handleUserUpdate} />;
            case 'services':
                return <ServicesTab userDetails={userDetails} onUserUpdate={handleUserUpdate} />;
            case 'availability':
                return <AvailabilityTab userDetails={userDetails} onUserUpdate={handleUserUpdate} />;
            case 'appointments':
                return <AppointmentsTab userDetails={userDetails} />;
            case 'messages':
                return <MessagesTab userDetails={userDetails} />;
            case 'reviews':
                return <RatingsTab userDetails={userDetails} />;
            default:
                return <ProfileTab userDetails={userDetails} onUserUpdate={handleUserUpdate} />;
        }
    };

    if (!userDetails) {
        return (
            <div className="dashboard-container">
                <div className="loaderContainer">
                    <div className="loader"></div>
                </div>
            </div>
        );
    }

    return (
        <div className={`dashboard-container ${isSidebarOpen ? 'sidebar-open' : ''}`}>
            <Sidebar
                activeTab={activeTab}
                onTabChange={handleTabChange}
                userRole={userRole}
            />
            <main className="dashboard-main">
                {renderTabContent()}
            </main>
        </div>
    );
};

export default Account;
